import { GroupOptions } from './group-options-model';

export const EMPTY_GROUPING_OPTIONS: GroupOptions = {
  groupBy: [],
  groupByFieldType: [],
  groupByFieldAggregationMode: [],
};
